// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
declare function require(moduleName: string): any;
export const environment = {
    production: false,
    ratePlansContractsEndpoint: 'https://myorder-api-engr.devicewise.com/api/v1/contracts',
    version: require('../../package.json').version,
    company: {
        entityRegisteredName: 'Telit IoT Solutions, Inc.',
        entityName: 'Telit IoT Solutions, Inc.'
    },
    /// if useMock is true an httpInterceptor will return data from mock folder before making an http call
    useMock: false,
    instances: {
        "engr-us" : {
            "key": "engr-us",
            "name": "Engineering-US",
            "endpoint": "engr-api.devicewise.com/api",
            "switchGroup": "engr",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "mapsHost": "https://engr.devicewise.com",
            "connectedApps": {
                "iotp": "https://mgmt-engr.devicewise.com/app/sso"
            }
        },
        "stage-us" : {
            "key": "stage-us",
            "name": "Stage-US",
            "endpoint": "stage-api.devicewise.com/api",
            "switchGroup": "stage",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "mapsHost": "https://stage.devicewise.com"
        },
        "dev-us" : {
            "key": "dev-us",
            "name": "Developer-US",
            "endpoint": "api-dev.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json",
            "mapsHost": "https://dev.devicewise.com",
            "connectedApps": {
                "iotp": "https://mgmt-dev.devicewise.com/app/sso"
            }
        },
        "prod-us" : {
            "key": "prod-us",
            "name": "Production-US",
            "endpoint": "api-us.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://appcenter.telit.com",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "mapsHost": "https://portal-us.devicewise.com",
            "connectedApps": {
                "iotp": "https://mgmt-us.devicewise.com/app/sso"
            }
        },
        "prod-de" : {
            "key": "prod-de",
            "name": "Production-DE",
            "endpoint": "api-de.devicewise.com/api",
            "switchGroup": "prod",
            "appCenter": "https://appcenter.telit.com",
            "lnfUrl": "https://appcenter.telit.com/common/appcenter.telit.com.json",
            "instancesUrl": "https://appcenter.telit.com/common/instances.json",
            "mapsHost": "https://portal-de.devicewise.com",
            "connectedApps": {
                "iotp": "https://mgmt-de.devicewise.com/app/sso"
            }
        },
        "cust-cu" : {
            "key": "cust-cu",
            "name": "China Unicom",
            "endpoint": "device1-api.10646.cn/api",
            "switchGroup": "cu",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json"
        },
        "cust-swisscom" : {
            "key": "cust-swisscom",
            "name": "Swisscom",
            "endpoint": "api.iotcloud.swisscom.com/api",
            "switchGroup": "swisscom",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json"
        },
        "cust-swisscom-test" : {
            "key": "cust-swisscom-test",
            "name": "Swisscom (Test)",
            "endpoint": "api-test.iotcloud.swisscom.com/api",
            "switchGroup": "swisscom",
            "appCenter": "https://portal-engr.telit.com",
            "lnfUrl": "https://portal-engr.telit.com/common/portal-engr.telit.com.json",
            "instancesUrl": "https://portal-engr.telit.com/common/instances.json"
        }
    }
};

export const disabledMCCs = ['432', '467', '250', '417', '368', '257'];

export const operators = {
    'AT&T': '0057B8',
    'Orange/Partner Co. Ltd.': '2cd5c4',
    TIM: '00468C',
    'T-Mobile': 'e20074',
    Verizon: 'D52B1E',
    Vodafone: 'e60000',
    Pelephone: '0177bd',
};
export const radioTechnology = {
    'gsm': '2f7ed8',
    'td-scdma': '0d233a',
    'wcdma': '8bbc21',
    'wimax': '910000',
    'cdma2000': '1aadce',
    'lte-tdd': '492970',
    'lte-fdd': 'f28f43',
    'wlan': '77a1e5',
    'bluetooth': '0000ff',
    'ethernet': 'c42525',
    'dsl': 'a6c96a',
    'plc': 'd90ae5',
};

export const maxNumberInFileUpload = 10000;
export const maxNumberOfEIDsInRecruiter = 50;
export const maxNumberOfEIDsInFileUpload = 10000;
export const defaultAppCenterUrl = 'https://portal-engr.telit.com';
export const defaultDwopenEndpoint = "https://engr-api.devicewise.com/api";
// Absolute host of the dwportal Maps API ('/maps/getTileConfig', '/maps/geocode').
// The built CMP JS is served as static assets from a CDN with no server-side
// proxy in production, so relative '/maps/*' paths do NOT work outside of
// `ng serve` (which only works locally because of proxy.conf.js). Every
// environment must therefore call this host directly (absolute, cross-origin)
// both in dev and in production so behavior is identical in both.
export const defaultMapsHost = 'https://engr.devicewise.com';
